import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    minHeight: 200
  },
  infoTextBox: {
    justifyContent: 'space-between'
  },
  mt2: {
    marginTop: theme.spacing(2)
  }
}));
